import React, { forwardRef } from "react"
import Logo from "assets/image/LogoAJB.png"
import { InfoSection, TableSection } from "./Section"

const PrintFakturPenjualan = forwardRef(({ dataInfo, dataTable }, ref) => {
  const KopSurat = () => {
    return (
      <div className="d-flex justify-content-start">
        <div>
          <img src={Logo} width={110} />
        </div>
        <div style={{ marginLeft: 30, textAlign: "left" }}>
          <p>
            <b>PT. ADI JAYA BETON</b><br />
            Jl. ByPass Ngurah Rai<br />
            Telp. : (0361) 467342, 467343<br />
            Fax: (0361) 467301<br />
          </p>
        </div>
      </div>
    )
  }

  return (
    <div className="container my-5 px-5" ref={ref}>
      <KopSurat />

      <div className="text-center h5 font-weight-bold mt-1 mb-3">
        <u>Faktur Penjualan</u>
      </div>

      <InfoSection dataInfo={dataInfo} />
      <br />
      <TableSection dataInfo={dataInfo} dataTable={dataTable} />
    </div >
  )
})

export default PrintFakturPenjualan